/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable react/no-did-mount-set-state */
import React, { Fragment } from 'react';
import GeoApi from '../../../api/destinations';
import Mundigea from '../../../api/mundigea';
import './getAgency.css';

export default class GetAgency extends React.Component {
  state = {
    provinceSelected: null,
    provinces: [],
    localities: [],
    localitiesFiltered: [],
  }

  componentDidMount = async () => {
    const [provinces, localities] = await Promise.all([
      GeoApi.getProvincias().then((res) => res),
      GeoApi.getLocalidades().then((res) => res),
    ]);
    this.setState({
      provinces: provinces.sort((a, b) => ((a.descripcion > b.descripcion) ? 1 : ((b.descripcion > a.descripcion) ? -1 : 0))),
      localities,
    });
  }

  filterLocalities = (provinceId) => {
    const localitiesFiltered = this.state.localities
      .filter((item) => item.provinciaId === parseInt(provinceId))
      .sort((a, b) => ((a.descripcion > b.descripcion) ? 1 : ((b.descripcion > a.descripcion) ? -1 : 0)));

    this.setState({
      provinceSelected: provinceId,
      localitiesFiltered,
    });
  }

  getAgency = (e) => {
    this.setState({
      agency: { loading: true, data: null },
    });
    const localidadId = e.target.value;
    const provinciaId = this.state.provinceSelected;
    Mundigea.obtenerAgenciaDerivacion({
      provinciaId,
      localidadId,
      appId: 1,
      tipoAccion: 2, // action buy
    }).then((res) => {
      this.setState({
        agency: { loading: false, data: res },
      }, () => {
        this.props.handleDerive(res);
      });
    });
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'provinceSelected') {
      this.filterLocalities(value);
    } else if (name === 'localitySelected') {
      this.getAgency(e);
    }
  }

  renderAgency = () => {
    const { loading, data } = this.state.agency;
    return (
      <div className='agency-container'>
        {loading
          ? (
            <div className='loading panel panel-default custom'>
              <i className='fa fa-spinner fa-spin' aria-hidden='true' />
            </div>
          )
          : (
            <div className='panel panel-default custom asesor'>
              <div className='panel-body'>
                <div className='titulo-asesor'>Tu asesor en esta compra sera</div>
                <h4 style={{ margin: '9px 0 3px 0' }}>{data.nombre}</h4>
                <div className='info'>
                  Direccion:
                  <span>{data.direccion}</span>
                </div>
                <div className='info'>
                  Telefono:
                  <span>{data.telefono}</span>
                </div>
                <div className='info'>
                  Mail:
                  <span>{data.email}</span>
                </div>
              </div>
            </div>
          )}
      </div>
    );
  }

  render() {
    const { provinces, provinceSelected, localitiesFiltered, agency } = this.state;
    return (
      <>
        <div className='clearfix'>
          <div className='col-md-4 col-sm-12'>
            <div className='form-group'>
              <label className='control-label' htmlFor='provinceSelected'>Provincia</label>
              <select
                onChange={this.handleChange}
                name='provinceSelected'
                id='provinceSelected'
                placeholder='test'
                className='form-control input-md'
                required
              >
                <option value=''>Seleccionar</option>
                {provinces.map((province) => (
                  <option key={province.id} value={province.id}>{province.descripcion}</option>
                ))}
              </select>
            </div>
          </div>
          <div className='col-md-4 col-sm-12'>
            <div className='form-group'>
              <label className='control-label' htmlFor='localitySelected'>Localidad</label>
              <select
                onChange={this.handleChange}
                name='localitySelected'
                id='localitySelected'
                placeholder='test'
                className='form-control input-md'
                disabled={provinceSelected && provinceSelected !== 0 ? '' : 'disabled'}
                required
              >
                <option value=''>Seleccionar</option>
                {localitiesFiltered.map((localitie) => (
                  <option key={localitie.id} value={localitie.id}>{localitie.descripcion}</option>
                ))}
              </select>
            </div>
          </div>
        </div>
        <div className='col-lg-12'>
          {agency && (this.renderAgency())}
        </div>
      </>
    );
  }
}
